import { GET_FEEDBACK_VENUE_DETAILS_ACTION_TYPE, INSERT_FEEDBACK_ACTION_TYPE,GET_FEEDBACK_DETAILS_ACTION_TYPE } from "../../utils/constants"


const initialState = [];

function feedbackReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_FEEDBACK_VENUE_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case INSERT_FEEDBACK_ACTION_TYPE:
            return [...state, payload];
        case GET_FEEDBACK_DETAILS_ACTION_TYPE:
            return [...state, payload];
        default:
            return state;
    }
};

export default feedbackReducer;